module.exports = __webpack_public_path__ + "img/ruleTitle.b1034b03.png";